var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"from-file",attrs:{"autocomplete":"off","type":"file","accept":"image/png, image/jpeg, image/jpg","id":"headshot","required":""},on:{"change":_vm.Headshot}}),_vm._v(" "),_c('label',{staticClass:"img-label Face-label",attrs:{"for":"headshot"}},[_c('img',{staticClass:"from-img",attrs:{"src":_vm.headshot}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695d44f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/headshot.vue
// module id = null
// module chunks = 